import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LensPackage } from '../meta/IBrain';
import { colorActions } from '../redux/slices/color';
import { sunRule } from '../utils/functions';
import useCurrentCategory from './useCurrentCategory';

export function useProductImage() {
  const imageFrameLayer =
    '##URL##/extra/image/rxc/frames/##MODEL##__##COLOR##__RXP__FRAME__qt.png';
  const imageLens =
    '##URL##/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png';
  const logoMap = {
    'Costa Del Mar': 'LOGO01',
    'Ray-Ban_C': 'LOGO02',
    'Ray-Ban_P': 'LOGO03',
    'Ray-Ban': 'LOGO04',
    Oakley: 'LOGO05',
    Arnette: 'LOGO08',
    Arnette_P: 'LOGO09',
  };
  const imageLogo =
    '##URL##/extra/image/rxc/logo/##MODEL##__RXP__##LOGO##__qt.png';
  const imageLensNoLogoLayer =
    '?impolicy=CompositeNoLogo&Lenses=##URL##/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png';
  const imageLensLogoLayer =
    '?impolicy=CompositeLogo&Lenses=##URL##/extra/image/rxc/lenses/##MODEL##__RXP__##CLEN##__qt.png';
  const imageLogoLayer =
    '&Logo=##URL##/extra/image/rxc/logo/##MODEL##__RXP__##LOGO##__qt.png';

  const currentStep = window.rxcBrain.currentStep;

  const flowDefiningAttributes = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes
  );

  const baseUrlCdn =
    flowDefiningAttributes?.assetsCDN ||
    window.rxcBrain.config.baseURLs?.assetsCDN;

  const selectedColor = useSelector((state: any) => state.color?.colorSelected);
  const selectedFrameColor = useSelector(
    (state: any) => state?.color.frameColorSelected
  );
  const brandFrame = window.rxcBrain.config?.data?.frame?.brand;
  const brandConfig = window.rxcBrain.config.brand;

  const imageUrl =
    window.rxcBrain.config?.data?.frames?.length > 0
      ? selectedFrameColor?.imageUrl
      : window.rxcBrain.config?.data?.frame?.imageUrl;

  const modelFrame = window.rxcBrain.config?.data?.frame?.model;

  const colorFrame =
    window.rxcBrain.config?.data?.frames?.length > 0
      ? selectedFrameColor?.clen
      : window.rxcBrain.config?.data?.frame?.color;

  const category = useCurrentCategory();

  const lensBrand = useSelector((state: any) => state.color?.lensBrand);
  const stepColor = useSelector((state: any) => state.color?.stepColor);

  const [cancelToken, setCancelToken] = useState(null);
  const [urlImage, setUrlImage] = useState(selectedColor ? null : imageUrl);

  const dispatch = useDispatch();

  const currentPackages = useSelector(
    (state: any) => state.workflow?.currentStepPackages?.validRXPackages
  );

  const frameImgUrl = useSelector((state: any) => state.color?.frameImgUrl);
  const clearClen = useSelector((state: any) => state.color?.clearClen);

  const getBrandByType = (isPolar: boolean) => {
    let brand = lensBrand ?? brandFrame;
    let ret = null;
    if (isPolar && brand === 'Ray-Ban') {
      ret = logoMap[brand + '_P'];
    }

    if (!ret) ret = logoMap[brand];

    return ret;
  };
  const fallbackImage = () => {
    dispatch(colorActions.setIsLoading(false));
    setUrlImage(frameImgUrl || imageUrl);
    dispatch(colorActions.setUrlImageGlobal(frameImgUrl || imageUrl));
    dispatch(
      colorActions.setShowFallbackImageMessage(clearClen ? false : true)
    );
  };

  const isColoredTreatment = () => {
    return currentPackages?.every((pkg: LensPackage) => {
      return (
        pkg.lensPackage?.coloredTreatment &&
        pkg.lensPackage?.coloredTreatment !== ''
      );
    });
  };

  useEffect(() => {
    const coloredTreatment = isColoredTreatment();
    const sun = currentPackages?.find((cp: any) => sunRule(cp.lensPackage));

    const colorInStepChain = window.rxcBrain.stepChain.find((sc) =>
      sc?.params?.find((p) => p?.key === 'color' && p?.value)
    );

    if (
      colorFrame &&
      ((selectedColor &&
        // (category === 'SUNGLASSES' ||
        //   (sun !== null && sun !== undefined) ||
        //   currentStep?.key === 'MixAndMatch') &&
        currentStep) ||
        // (currentStep.progressive <=
        //   window.rxcBrain?.findByStepKey('LensColour')?.progressive ||
        //   window.rxcBrain.isLastStep())
        coloredTreatment ||
        clearClen)
    ) {
      let url = imageFrameLayer
        .replace('##MODEL##', modelFrame)
        .replace('##COLOR##', colorFrame)
        .replace('##URL##', baseUrlCdn);

      if (
        // currentStep?.key !== 'MixAndMatch' &&
        !colorInStepChain &&
        (stepColor !== currentStep?.key || !selectedColor) &&
        !coloredTreatment
      ) {
        setUrlImage(imageUrl);
        dispatch(colorActions.setUrlImageGlobal(imageUrl));
        dispatch(colorActions.selectColor(null));
        dispatch(colorActions.selectTransition(null));
        dispatch(colorActions.setCardTransitionImage(null));
        dispatch(colorActions.setSwatchUrl(null));
      } else if (currentPackages && currentPackages.length > 0) {
        const packagesFromColor = coloredTreatment
          ? []
          : currentPackages.filter(
              (cp) => cp.lensPackage.color === selectedColor
            );
        const selectedColoredTreatment = coloredTreatment
          ? currentPackages[0].lensPackage?.coloredTreatment
          : null;
        if (
          packagesFromColor.length > 0 ||
          selectedColoredTreatment ||
          clearClen
        ) {
          const selectedColorPackage = packagesFromColor.length
            ? packagesFromColor[0]
            : selectedColoredTreatment;
          let urlLensesImage = imageLens
            .replace('##MODEL##', modelFrame)
            .replace(
              '##CLEN##',
              selectedColoredTreatment
                ? selectedColoredTreatment
                : clearClen
                  ? clearClen
                  : selectedColorPackage.lensPackage.clen
            )
            .replace('##URL##', baseUrlCdn);

          if (cancelToken) cancelToken.cancel();
          const CancelToken = axios.CancelToken;
          const source = CancelToken.source();
          setCancelToken(source);

          dispatch(colorActions.setError(false));
          dispatch(colorActions.setIsLoading(true));
          dispatch(colorActions.setIsLoading(true));

          axios
            .get(urlLensesImage, {
              cancelToken: source.token,
            })
            .then(() => {
              if (brandFrame && (!lensBrand || brandFrame == lensBrand)) {
                const imageLogoMapped = getBrandByType(
                  selectedColoredTreatment
                    ? selectedColoredTreatment
                    : selectedColorPackage?.lensPackage?.polar
                );
                let urlLogoImage = imageLogo
                  .replace('##MODEL##', modelFrame)
                  .replace('##LOGO##', imageLogoMapped)
                  .replace('##URL##', baseUrlCdn);
                return axios
                  .get(urlLogoImage, {
                    cancelToken: source.token,
                  })
                  .then(() => {
                    let compositionLens = imageLensLogoLayer
                      .replace('##MODEL##', modelFrame)
                      .replace(
                        '##CLEN##',
                        selectedColoredTreatment
                          ? selectedColoredTreatment
                          : clearClen
                            ? clearClen
                            : selectedColorPackage?.lensPackage?.clen
                      )
                      .replace('##URL##', baseUrlCdn);
                    url += compositionLens;
                    let compositionLogo = imageLogoLayer
                      .replace('##MODEL##', modelFrame)
                      .replace('##LOGO##', imageLogoMapped)
                      .replace('##URL##', baseUrlCdn);
                    url += compositionLogo;
                    return axios.get(url, {
                      cancelToken: source.token,
                    });
                  });
              } else {
                let compositionLens = imageLensNoLogoLayer
                  .replace('##MODEL##', modelFrame)
                  .replace(
                    '##CLEN##',
                    selectedColoredTreatment
                      ? selectedColoredTreatment
                      : selectedColorPackage.lensPackage.clen
                  )
                  .replace('##URL##', baseUrlCdn);
                url += compositionLens;
                return axios.get(url, {
                  cancelToken: source.token,
                });
              }
            })
            .then(() => {
              setUrlImage(url);
              dispatch(colorActions.setUrlImageGlobal(url));
              dispatch(colorActions.setError(true));
              dispatch(colorActions.setShowFallbackImageMessage(false));
              dispatch(colorActions.setShowNotFoundImageMessage(false));
              dispatch(colorActions.setIsLoading(false));
            })
            .catch((error) => {
              if (!selectedColoredTreatment && error.isAxiosError) {
                dispatch(colorActions.setIsLoading(true));
                return fallbackImage();
                // selectedColoredTreatment
                //     ? selectedColoredTreatment
                //     : selectedColorPackage.lensPackage.clen
              }
            });
        }
      }
    } else {
      if (currentStep?.key === 'MixAndMatch') {
        // Se siamo dentro SUPERNOVA e ci spostiamo sulle prescription resettiamo l'immagine (dato che non abbiamo colori)
        setUrlImage(imageUrl);
      } else {
        setUrlImage(imageUrl);
        dispatch(colorActions.setUrlImageGlobal(imageUrl));
        dispatch(colorActions.selectColor(null));
        dispatch(colorActions.selectTransition(null));
        dispatch(colorActions.setCardTransitionImage(null));
        dispatch(colorActions.setSwatchUrl(null));
      }
    }
  }, [
    lensBrand,
    selectedColor,
    category,
    currentPackages,
    colorFrame,
    clearClen,
    imageUrl,
  ]);

  useEffect(() => {
    if (!imageUrl) return;
    setUrlImage(imageUrl);
  }, [imageUrl]);

  //supernova
  useEffect(() => {
    if (!frameImgUrl) return;
    setUrlImage(frameImgUrl);
  }, [frameImgUrl]);

  return { urlImage };
}
